// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"Tooltip_tooltipContainer__E9pQD","tooltip":"Tooltip_tooltip__8C3Kt"};